import { Badge, Card, Text } from "@shopify/polaris"
import classNames from "classnames"
import { useEffect, useMemo, useState } from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"

import TitleGroup from "@/component/TitleGroup/TitleGroup"
import stores from "@/stores"

import styles from "./index.module.scss"

type ExtensionInfo = {
  handle: string
  activations?: Array<{
    target: string
    handle: string
    activations: Array<{
      target: string
      handle: string
    }>
  }>
}

const AppBlocksStatus = () => {
  const { t } = useTranslation("dashboard")
  const [extensions, setExtensions] = useState<ExtensionInfo[]>([])
  const navigator = useNavigate()

  useEffect(() => {
    const checkExtensions = async () => {
      try {
        const { shopify } = window as any

        let extensionsData: ExtensionInfo[] = []

        // Shopify Admin 环境
        if (shopify?.app) {
          extensionsData = await shopify.app.extensions() as ExtensionInfo[]
          setExtensions(extensionsData)
        }
      } catch (e) {
        console.log(e)
      }
    }

    // 这个查询在首页有性能问题，导致别的菜单页到首页会刷新首页
    setTimeout(() => {
      checkExtensions()
    }, 300)
  }, [])

  // 根据 extensions 数据计算每个 App Block 的状态
  const list = useMemo(() => {
    const trackOrderButton = extensions.find(ext => ext.handle === "track-order-button")
    const customerTrackingPage = extensions.find(ext => ext.handle === "customer-tracking-page")
    const trackingWidget = extensions.find(ext => ext.handle === "tracking-widget")
    const fulfillmentStatus = extensions.find(ext => ext.handle === "tracking-fulfillment-status")
    const themeAppExtension = extensions.find(ext => ext.handle === "theme-app-extension")
    const insCheckout = extensions.find(ext => ext.handle === "ins-checkout")

    let hasPrePurchaseEDD = false
    let ShippingProtection = false
    let NonDefaultOrderLookupWidget = false

    const hasTrackOrderButton = !!trackOrderButton?.activations?.length
    const hasCustomerTrackingPage = !!customerTrackingPage?.activations?.length
    const hasTrackingWidget = !!trackingWidget?.activations?.length
    const hasFulfillmentStatus = !!fulfillmentStatus?.activations?.length
    const hasInsCheckout = !!insCheckout?.activations?.length

    let InsCheckoutCount = insCheckout?.activations?.length ? 1 : 0

    if (hasInsCheckout){
      ShippingProtection = true
    }

    const CustomerAccountOrderTrackingNumbers = [hasTrackOrderButton, hasCustomerTrackingPage, hasTrackingWidget, hasFulfillmentStatus].filter(item => item).length

    themeAppExtension?.activations?.forEach(item => {
      if (item.handle === "edd" && item.activations.length > 0){
        hasPrePurchaseEDD = true
      }
      if (item.handle === "app.embed" && item.activations.length > 0){
        ShippingProtection = true
        InsCheckoutCount = InsCheckoutCount + 1
      }
      if (item.handle === "app" && item.activations.length > 0){
        NonDefaultOrderLookupWidget = true
      }
    })
    return [
      {
        title: t("CustomerAccountOrderTracking"),
        isAdded: CustomerAccountOrderTrackingNumbers > 0,
        addNums: CustomerAccountOrderTrackingNumbers || 0,
        onClick: () => navigator("/settings", { state: { builtForCustomerAccountsTip: true } }),
      },
      {
        title: t("PrePurchaseEDD"),
        isAdded: hasPrePurchaseEDD,
        onClick: () => navigator("/settings/pre_purchase_edd"),
      },
      {
        title: t("ShippingProtection"),
        isAdded: ShippingProtection,
        onClick: () => navigator("/protection"),
        addNums: stores.userInfoSore.data.shop_plan_display_name.toLowerCase().includes("plus")  ? InsCheckoutCount : undefined,
      },
      {
        title: t("NonDefaultOrderLookupWidget"),
        isAdded: NonDefaultOrderLookupWidget,
        onClick: () => navigator("/tracking-page/trackingPageUrl"),
      },
    ]
  }, [extensions, t])

  return <Card padding={"400"}>
    <TitleGroup title={t("AppBlocksStatus")} subTitle={t("AppBlocksStatusDesc")} />

    <div className={"mt-4"}>
      <div className={"flex flex-wrap gap-x-4 gap-y-3"}>
        {list.map((item, index) => (
          <div key={index} className={classNames("w-full md:flex-1 md:min-w-[calc(50%-0.75rem)]", styles.HelpCenter__Item)}>
            <a className={"flex justify-between"} onClick={item.onClick}>
              <Text variant="bodyMd" as="p">{item.title}</Text>

              <Badge tone={item.isAdded ? "success" : undefined}>
                {
                  item.isAdded
                    ? item.addNums ? t("NumberAdded", { count: item.addNums }) : t("Added")
                    : t("NotAdded")
                }
              </Badge>
            </a>

          </div>
        ))}
      </div>
    </div>
  </Card>
}

export default AppBlocksStatus
